/**
 * Mock API responses for the component-based ad system.
 * Shape mirrors what the real API will return:
 *   { components: [{ name, props, componentData }] }
 *
 * Three variants based on slider ratio:
 *  MOCK_AD_COMPONENTS        — Default (no ratio): full mix of all components
 *  MOCK_AD_COMPONENTS_300x250 — 300x250 ratio: only MatchHeadWidget (fits 300x250)
 *  MOCK_AD_COMPONENTS_300x600 — 300x600 ratio: only MatchTimeline + MatchStats (fits 300x600)
 */

// ── Shared component data ────────────────────────────────────────────────────

const MATCH_HEAD_1 = {
  name: "MatchHeadWidget",
  props: { width: "300px", height: "250px" },
  componentData: {
    status: 200,
    message: "Match detail",
    data: {
      id: 164720,
      dt: "2025-05-25 15:00:00",
      st: "Finished",
      ro: "Round 38",
      cp: "90",
      ft: "2-0",
      ht: "0-0",
      et: "",
      ps: "",
      cfs: "2-0",
      mins: "FT",
      win: 1,
      tournament_id: 1889,
      std: "Old Trafford",
      competitors: {
        match_id: 164720,
        htid: 20,
        htn: "Manchester United",
        atn: "Aston Villa",
        atid: 12,
        htf: ["D", "W", "W", "W", "W"],
        atf: ["L", "W", "D", "L", "W"],
      },
      match_official: [],
      odds: null,
      venue: { id: 10013, name: "Old Trafford", capacity: "74,310" },
      tournament: {
        id: 1889,
        nm: "Premier League",
        sg: "premier-league-1889",
        football_category_id: 907,
        cat: "England",
        football_category: {
          id: 48,
          nm: "England",
          fb_category_id: 907,
          fid: 60,
        },
      },
    },
  },
};

const MATCH_HEAD_2 = {
  name: "MatchHeadWidget",
  props: { width: "300px", height: "250px" },
  componentData: {
    status: 200,
    message: "Match detail",
    data: {
      id: 350868,
      aimId: null,
      dt: "2026-02-18 19:45:00",
      st: "NSY",
      ro: "Round 33",
      cp: "NSY",
      ft: "",
      ht: "",
      et: "",
      ps: "",
      cfs: "",
      mins: "NSY",
      tournament_id: 4336,
      football_venue_id: 10024,
      sut: "0000-00-00 00:00:00",
      sun: "",
      im: "0",
      pm: "0",
      f_time: "2026-02-10 13:05:16",
      ref: "",
      std: "DW Stadium",
      cap: "",
      competitors: {
        match_id: 350868,
        htid: 27,
        htn: "Wigan Athletic",
        atn: "Luton Town",
        atid: 21,
        htf: ["L", "L", "L", "L", "L"],
        atf: ["L", "W", "W", "L", "L"],
      },
      match_official: [],
      odds: null,
      venue: { id: 10024, name: "DW Stadium", capacity: "" },
      tournament: {
        id: 4336,
        nm: "League One",
        sg: "league-one-4336",
        football_category_id: 907,
        cat: "England",
        football_category: {
          id: 48,
          nm: "England",
          fb_category_id: 907,
          fid: 60,
        },
      },
    },
  },
};

const MATCH_TIMELINE = {
  name: "MatchTimeline",
  props: { width: "300px", height: "600px" },
  componentData: {
    status: 200,
    message: "Match summary",
    summary: {
      timeline: [
        {
          sc: "1-0",
          pl_nm: "Tonali Sandro",
          mins: 2,
          typ: "Goal",
          isH: 1,
          asst: "Jacob Murphy",
        },
        { pl_nm: "Jackson Nicolas", mins: 33, typ: "Yellow card", isH: 0 },
        { pl_nm: "Jackson Nicolas", mins: 35, typ: "Red card", isH: 0 },
        { pl_nm: "Maresca Enzo", mins: 39, typ: "Yellow card", isH: 0 },
        { pl_nm: "Fernandez Enzo", mins: 45, typ: "Yellow card", isH: 0 },
        { mins: 0, pl_nm: "", typ: "HT", sc: "1 - 0" },
        {
          pl_in_nm: "James Reece",
          pl_out_nm: "Madueke Noni",
          mins: 46,
          typ: "Sub",
          isH: 0,
        },
        { pl_nm: "Schaer Fabian", mins: 53, typ: "Yellow card", isH: 1 },
        {
          pl_in_nm: "Miley Lewis",
          pl_out_nm: "Botman Sven",
          mins: 55,
          typ: "Sub",
          isH: 1,
        },
        { pl_nm: "Murphy Jacob", mins: 64, typ: "Yellow card", isH: 1 },
        {
          pl_in_nm: "Krafth Emil",
          pl_out_nm: "Gordon Anthony",
          mins: 65,
          typ: "Sub",
          isH: 1,
        },
        {
          pl_in_nm: "Sancho Jadon",
          pl_out_nm: "Chalobah Trevoh",
          mins: 75,
          typ: "Sub",
          isH: 0,
        },
        {
          pl_in_nm: "Gusto Malo",
          pl_out_nm: "Lavia Romeo",
          mins: 75,
          typ: "Sub",
          isH: 0,
        },
        { pl_nm: "Guimaraes Bruno", mins: 84, typ: "Yellow card", isH: 1 },
        { pl_nm: "Krafth Emil", mins: 89, typ: "Yellow card", isH: 1 },
        { pl_nm: "Colwill Levi", mins: 90, typ: "Yellow card", isH: 0 },
        {
          sc: "2-0",
          pl_nm: "Guimaraes Bruno",
          mins: 90,
          typ: "Goal",
          isH: 1,
          asst: "Daniel Burn",
        },
        {
          pl_in_nm: "Wilson Callum",
          pl_out_nm: "Isak Alexander",
          mins: 90,
          typ: "Sub",
          isH: 1,
        },
        {
          pl_in_nm: "Longstaff Sean",
          pl_out_nm: "Guimaraes Bruno",
          mins: 90,
          typ: "Sub",
          isH: 1,
        },
      ],
      red_cards: [35],
      yellow_cards: [33, 39, 45, 53, 64, 84, 89, 90],
      ref: "",
      std: "St James' Park",
      tv_schedule: [],
    },
    data: {
      id: 164720,
      cfs: "2-0",
      competitors: {
        htid: 20,
        htn: "Newcastle United",
        atid: 2,
        atn: "Chelsea",
      },
      tournament: { id: 1889, nm: "Premier League" },
    },
  },
};

const MATCH_STATS = {
  name: "MatchStatsWidget",
  props: { width: "300px", height: "600px" },
  componentData: {
    status: 200,
    message: "Match stats",
    match: {
      data: {
        id: 164720,
        cfs: "2-0",
        st: "Finished",
        competitors: {
          htid: 20,
          htn: "Newcastle United",
          atid: 2,
          atn: "Chelsea",
        },
        tournament: { id: 1889, nm: "Premier League" },
      },
    },
    stats: {
      first_half: {
        shots_on_target: { ht: 2, at: 0, sort: 1 },
        shots_off_target: { ht: 2, at: 3, sort: 2 },
        possession_percentage: { ht: 0, at: 0, sort: 3 },
        corner_kicks: { ht: 2, at: 1, sort: 4 },
        yellow_cards: { ht: 1, at: 1, sort: 5 },
        red_cards: { ht: 0, at: 0, sort: 6 },
        attacks: { ht: 0, at: 0, sort: 7 },
        dangerous_attacks: { ht: 0, at: 0, sort: 8 },
      },
      second_half: {
        shots_on_target: { ht: 2, at: 4, sort: 1 },
        shots_off_target: { ht: 1, at: 5, sort: 2 },
        possession_percentage: { ht: 0, at: 0, sort: 3 },
        corner_kicks: { ht: 1, at: 1, sort: 4 },
        yellow_cards: { ht: 2, at: 1, sort: 5 },
        red_cards: { ht: 0, at: 0, sort: 6 },
        attacks: { ht: 0, at: 0, sort: 7 },
        dangerous_attacks: { ht: 0, at: 0, sort: 8 },
      },
      total: {
        shots_on_target: { ht: 4, at: 4, sort: 1 },
        shots_off_target: { ht: 3, at: 8, sort: 2 },
        possession_percentage: { ht: 29, at: 71, sort: 3 },
        corner_kicks: { ht: 3, at: 2, sort: 4 },
        yellow_cards: { ht: 3, at: 2, sort: 5 },
        red_cards: { ht: 0, at: 0, sort: 6 },
        attacks: { ht: 0, at: 0, sort: 7 },
        dangerous_attacks: { ht: 0, at: 0, sort: 8 },
      },
    },
  },
};

const FAN_VOTE = {
  name: "FanVoteWidget",
  props: { width: "300px", height: "600px" },
  componentData: {
    question: "Who will win the title this season?",
    category: "Fan Vote",
    league: "Premier League",
    emoji: "\u26BD",
    apiUrl: "",
    options: [
      { id: "arsenal", label: "Arsenal" },
      { id: "mancity", label: "Man City" },
      { id: "liverpool", label: "Liverpool" },
    ],
  },
};

// ── Exports ──────────────────────────────────────────────────────────────────

/** Default (no ratio): full mix — MatchHead → Timeline → MatchHead → Stats → FanVote */
export const MOCK_AD_COMPONENTS = {
  components: [
    MATCH_HEAD_1,
    MATCH_TIMELINE,
    MATCH_HEAD_2,
    MATCH_STATS,
    FAN_VOTE,
  ],
};

/** 300x250 ratio: only MatchHeadWidget entries */
export const MOCK_AD_COMPONENTS_300x250 = {
  components: [MATCH_HEAD_1, MATCH_HEAD_2],
};

/** 300x600 ratio: MatchTimeline + MatchStats + FanVote (tall components) */
export const MOCK_AD_COMPONENTS_300x600 = {
  components: [MATCH_TIMELINE, MATCH_STATS, FAN_VOTE],
};
